import React from 'react';
import { Divider } from '@adobe/react-spectrum';
import Wrap from './styles';

const PageSectionDivider = props => {
  return (
    <Wrap>
      <Divider {...props} />
    </Wrap>
  );
};

export default PageSectionDivider;
